/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectTaxesTaxStandardCreate } from '../fn/taxes-standard/project-taxes-tax-standard-create';
import { projectTaxesTaxStandardCreate$FormData } from '../fn/taxes-standard/project-taxes-tax-standard-create-form-data';
import { ProjectTaxesTaxStandardCreate$FormData$Params } from '../fn/taxes-standard/project-taxes-tax-standard-create-form-data';
import { ProjectTaxesTaxStandardCreate$Params } from '../fn/taxes-standard/project-taxes-tax-standard-create';
import { projectTaxesTaxStandardCreate$XWwwFormUrlencoded } from '../fn/taxes-standard/project-taxes-tax-standard-create-x-www-form-urlencoded';
import { ProjectTaxesTaxStandardCreate$XWwwFormUrlencoded$Params } from '../fn/taxes-standard/project-taxes-tax-standard-create-x-www-form-urlencoded';
import { projectTaxesTaxStandardDestroy } from '../fn/taxes-standard/project-taxes-tax-standard-destroy';
import { ProjectTaxesTaxStandardDestroy$Params } from '../fn/taxes-standard/project-taxes-tax-standard-destroy';
import { projectTaxesTaxStandardPartialUpdate } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update';
import { projectTaxesTaxStandardPartialUpdate$FormData } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update-form-data';
import { ProjectTaxesTaxStandardPartialUpdate$FormData$Params } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update-form-data';
import { ProjectTaxesTaxStandardPartialUpdate$Params } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update';
import { projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update-x-www-form-urlencoded';
import { ProjectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-standard/project-taxes-tax-standard-partial-update-x-www-form-urlencoded';
import { projectTaxesTaxStandardRetrieve } from '../fn/taxes-standard/project-taxes-tax-standard-retrieve';
import { ProjectTaxesTaxStandardRetrieve$Params } from '../fn/taxes-standard/project-taxes-tax-standard-retrieve';
import { projectTaxesTaxStandardUpdate } from '../fn/taxes-standard/project-taxes-tax-standard-update';
import { projectTaxesTaxStandardUpdate$FormData } from '../fn/taxes-standard/project-taxes-tax-standard-update-form-data';
import { ProjectTaxesTaxStandardUpdate$FormData$Params } from '../fn/taxes-standard/project-taxes-tax-standard-update-form-data';
import { ProjectTaxesTaxStandardUpdate$Params } from '../fn/taxes-standard/project-taxes-tax-standard-update';
import { projectTaxesTaxStandardUpdate$XWwwFormUrlencoded } from '../fn/taxes-standard/project-taxes-tax-standard-update-x-www-form-urlencoded';
import { ProjectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-standard/project-taxes-tax-standard-update-x-www-form-urlencoded';
import { BackendTaxStandardDto } from '../models/backend-tax-standard-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesStandardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxStandardCreate()` */
  static readonly ProjectTaxesTaxStandardCreatePath = '/api/project_taxes/tax_standard/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardCreate$Response(
    params: ProjectTaxesTaxStandardCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardCreate(
    params: ProjectTaxesTaxStandardCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxStandardCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardCreate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxStandardCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardCreate$FormData$Response(
    params: ProjectTaxesTaxStandardCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardCreate$FormData(
    params: ProjectTaxesTaxStandardCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxStandardRetrieve()` */
  static readonly ProjectTaxesTaxStandardRetrievePath = '/api/project_taxes/tax_standard/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxStandardRetrieve$Response(
    params: ProjectTaxesTaxStandardRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxStandardRetrieve(
    params: ProjectTaxesTaxStandardRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxStandardUpdate()` */
  static readonly ProjectTaxesTaxStandardUpdatePath = '/api/project_taxes/tax_standard/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardUpdate$Response(
    params: ProjectTaxesTaxStandardUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardUpdate(
    params: ProjectTaxesTaxStandardUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardUpdate$FormData$Response(
    params: ProjectTaxesTaxStandardUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardUpdate$FormData(
    params: ProjectTaxesTaxStandardUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxStandardDestroy()` */
  static readonly ProjectTaxesTaxStandardDestroyPath = '/api/project_taxes/tax_standard/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxStandardDestroy$Response(
    params: ProjectTaxesTaxStandardDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesTaxStandardDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxStandardDestroy(
    params: ProjectTaxesTaxStandardDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectTaxesTaxStandardDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxStandardPartialUpdate()` */
  static readonly ProjectTaxesTaxStandardPartialUpdatePath = '/api/project_taxes/tax_standard/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardPartialUpdate$Response(
    params: ProjectTaxesTaxStandardPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxStandardPartialUpdate(
    params: ProjectTaxesTaxStandardPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxStandardPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardPartialUpdate$FormData$Response(
    params: ProjectTaxesTaxStandardPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
    return projectTaxesTaxStandardPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxStandardPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxStandardPartialUpdate$FormData(
    params: ProjectTaxesTaxStandardPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxStandardDto> {
    return this.projectTaxesTaxStandardPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxStandardDto>): BackendTaxStandardDto => r.body),
    );
  }
}
